module.exports = __webpack_public_path__ + "img/tutov1.c6196c21.png";